import type { AxiosInstance } from "axios";
import { AxiosHeaders } from "axios";
import { LocalStorageKeys } from "@/core/@types/types";
import type { IHttpTokenInterceptor } from "./HttpTokenInterceptor";
import { handleSessionResponse, isAuthenticationRequest, ensureSessionToken, sessionRequestUrl } from "./SessionAuthentication";

export default class RawAxiosTokenInterceptor implements IHttpTokenInterceptor<AxiosInstance> {
  constructor(private readonly storage: Storage = localStorage) {}

  intercept(axios: AxiosInstance): void {
    axios.interceptors.request.use(async (config) => {
      const url = sessionRequestUrl(config.url, config.baseURL);
      if (isAuthenticationRequest(url)) return config;
      const token = await ensureSessionToken(this.storage.getItem(LocalStorageKeys.TokenNewHorizons), config.method || "GET", url);
      this.storage.setItem(LocalStorageKeys.TokenNewHorizons, JSON.stringify(token));
      const headers = AxiosHeaders.from(config.headers);
      if (!headers.get("Content-Type") && !(config.data instanceof FormData)) headers.set("Content-Type", "application/json");
      headers.set("X-Requested-With", "XMLHttpRequest");
      headers.set("Authorization", `Bearer ${token}`);
      config.headers = headers;

      return config;
    });
    axios.interceptors.response.use(async (response) => {
      await handleSessionResponse(response.status, response.config.method || "GET", sessionRequestUrl(response.config.url, response.config.baseURL), response.headers["x-location"]);

      return response;
    }, async (error) => {
      if (error.response) await handleSessionResponse(error.response.status, error.config.method || "GET", sessionRequestUrl(error.config.url, error.config.baseURL), error.response.headers?.["x-location"]);

      return Promise.reject(error);
    });
  }
}
